var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOricLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 20,
    fill: "#718EBF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1562 35.75C32.9024 35.75 36.75 31.9024 36.75 27.1562C36.75 22.4101 32.9024 18.5625 28.1562 18.5625C23.4101 18.5625 19.5625 22.4101 19.5625 27.1562C19.5625 31.9024 23.4101 35.75 28.1562 35.75ZM38.3125 27.1562C38.3125 32.7654 33.7654 37.3125 28.1562 37.3125C22.5471 37.3125 18 32.7654 18 27.1562C18 21.5471 22.5471 17 28.1562 17C33.7654 17 38.3125 21.5471 38.3125 27.1562Z",
    fill: "#718EBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1623 35.3471C34.2084 35.4096 34.2597 35.4694 34.3163 35.526L40.3327 41.5424C40.9428 42.1526 41.9322 42.1526 42.5424 41.5424C43.1526 40.9322 43.1526 39.9428 42.5424 39.3327L36.526 33.3163C36.4694 33.2597 36.4096 33.2084 36.3471 33.1623C35.7342 33.9968 34.9968 34.7342 34.1623 35.3471Z",
    fill: "#718EBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1562 21.6875C28.5877 21.6875 28.9375 22.0373 28.9375 22.4688V26.375H32.8438C33.2752 26.375 33.625 26.7248 33.625 27.1562C33.625 27.5877 33.2752 27.9375 32.8438 27.9375H28.9375V31.8438C28.9375 32.2752 28.5877 32.625 28.1562 32.625C27.7248 32.625 27.375 32.2752 27.375 31.8438V27.9375H23.4688C23.0373 27.9375 22.6875 27.5877 22.6875 27.1562C22.6875 26.7248 23.0373 26.375 23.4688 26.375H27.375V22.4688C27.375 22.0373 27.7248 21.6875 28.1562 21.6875Z",
    fill: "#718EBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOricLink);
export default __webpack_public_path__ + "static/media/oric-link.22549688000fa5d4779e8750d0465899.svg";
export { ForwardRef as ReactComponent };